<template>
  <div class="recording_warp">
    <div class="content_wrap">
      <img v-if="is_award=='2'" src="./../assets/img/bg4.png">
      <img v-if="is_award=='1'" src="./../assets/img/bg5.png">
      <div v-if="is_award=='1'" class="win_btn_gb" @click="closeClickzj"></div>
      <div v-if="is_award=='2'" class="win_btn_gb" @click="closeClick"></div>
      <div class="win_btn" @click="closeClick"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
     iswin: 1,
     
    };
  },
  props:{
    'is_award': Number
  },
  methods:{
    closeClick(){
      this.$emit('closeClick')
    },
    closeClickzj(){
      alert('领取成功');
      // this.$Message.success('领取成功')
      // wx.showToast({
      //   title: '领取成功',
      //   icon: 'none',
      //   duration: 1500
      // })
      setTimeout(() => {
        this.$emit('closeClick')
      }, 2000);
    }

  },
  onLoad() {
    Object.assign(this.$data, this.$options.data())//重置data初始化
  }
}
</script>

<style lang="less" scoped>
.recording_warp{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .84);
  z-index: 99;
  .content_wrap{
    width: 7.50rem;
    height: 7.16rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    img{
      width: 7.50rem;
      height: 7.16rem;
    }
    .win_btn{
      position: absolute; 
      left: 50%; 
      bottom: 0; 
      transform: translateX(-50%);
      width: 2.26rem; 
      height: .86rem; 
    }
    .win_btn_gb{
      position: absolute; 
      left: 50%; 
      bottom: 1.80rem; 
      transform: translateX(-50%);
      width: 3.48rem; 
      height: .90rem; 
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/winningInfo.vue